<section id="call-to-action" class="call-to-action " >
  <div class="container">
    <div class="row">
      <div class="col-lg-9 text-center text-lg-left">
        <h2 class="cta-title">Check out our Kindergarten Section</h2>
        <p class="cta-text"> Everyday is a celebration at Tagore Global School Kurukshetra</p>
  </div>
      <div class="col-lg-3 cta-btn-container text-center">
        <a class="cta-btn align-middle" routerLink="/kindergarten">Check Out</a>
      </div>
    </div>

  </div>
</section>